import AdminAddAndEditPollComponent from "../../Components/Admin/AdminAddAndEditPollComponent";
import SideBar from "../../Components/Admin/SideBar";

export default function AdminEditPollsPage() {
  return (
    <AdminAddAndEditPollComponent />
  )
}
